import { CommunicationType, IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `HouseCommunication` endpoint class.
 */
export interface IHouseCommunicationPathParameters extends IBaseQueryParameters {
  /**
   * The congress number. For example, the value can be `117` for the 117th
   * Congress.
   */
  congress?: number

  /**
   * The type of communication, which can be any of the following values:
   *
   * - `ec`
   * - `ml`
   * - `pm`
   * - `pt`
   */
  communicationType?: CommunicationType

  /**
   * The communications assigned number. For example, this value can be `3324`.
   */
  communicationNumber?: number
}
